import styled from "styled-components";

const Styles = styled.div`
  &.search-area {
    margin-bottom: 12px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    & .extra-area {
      display: inline-flex;
      align-items: center;
      flex-wrap: wrap;
      margin: 5px 0;
      & .ant-space {
        flex-wrap: wrap;
      }

      @media all and (max-width: 479px) {
        width: 100%;
      }
    }

    /* &.has-tit {
      .extra-area.left {
        margin-bottom: 0;
      }
    } */

    /* label, input 요소 세트 */
    & .condition-item {
      display: inline-flex;
      flex-wrap: nowrap;
      align-items: center;
      label:not([class*="ant-"]) {
        font-weight: 700;
        color: #5e6675;
        margin-right: 8px;
        flex-shrink: 0;
      }

      @media all and (max-width: 479px) {
        margin-right: 0px;

        & .ant-select {
          width: 100% !important;
        }
      }
    }

    @media all and (min-width: 768px) {
      & + &.search-area {
        margin-top: -8px;
      }
    }
  }

  & .page-tit-2 {
    font-size: 16px;
    height: 32px;
    line-height: 32px;
  }

  @media all and (max-width: 767px) {
    &.search-area {
      border: 1px solid #d8dbe3;
      padding: 15px 20px;
      background: #f7f8fa;
    }

    /* & .extra-area.right {
      margin-bottom: 0;
    }
    & .extra-area.left:last-child {
      margin-bottom: 0;
    } */
  }

  @media all and (max-width: 479px) {
    &.search-area {
      padding: 10px 15px;
    }
  }
`;

export default Styles;
